export default {
   // -----------Title----------
   information: 'Information',
   provideDetailsOfTheProfile: 'Provide details of the profile',
   categoryHierarchy: 'Category Hierarchy',
   setForFurtherLevelOfCategory: 'Set for further level of category',

   // -----------MUI-----------
   children: 'children',
   categoryName: 'Category Name',
   brandName: 'Brand Name',
   uomName: 'Uom Name',
   subCategory: 'Sub Category',

   metricType: 'Metric Type',
   metricTypeDisplayName: 'Metric Type Display Name',
   decimalPlacesDigit: 'Decimal Places Digit',
};